import { PageHero } from "@/components/site/PageHero";
import { Reveal, Overline } from "@/components/site/Reveal";
import { CTABand } from "@/components/site/CTABand";
import { accreditations, IMAGES } from "@/data/content";
import { BadgeCheck, ShieldCheck, FileCheck2, Recycle } from "lucide-react";

const commitments = [
  { icon: ShieldCheck, title: "Vetting & licensing", body: "All security personnel are SIA-licensed and screened to BS 7858 standards before deployment." },
  { icon: FileCheck2, title: "Documented processes", body: "Method statements, risk assessments and full audit trails on every site and service." },
  { icon: Recycle, title: "Responsible waste", body: "Licensed waste carrier with full duty-of-care documentation and recycling-first disposal." },
  { icon: BadgeCheck, title: "Insured & assured", body: "Comprehensive public and employers' liability cover, with continual quality audits." },
];

export default function Accreditations() {
  return (
    <div>
      <PageHero
        overline="Accreditations & Compliance"
        title={["Standards you", "can build a", "contract on."]}
        subtitle="Compliance is at the heart of everything we do. Our accreditations and licences give clients complete confidence that every service is delivered safely and legally."
        image={IMAGES.office}
      />

      <section className="bg-ink py-20 md:py-28 border-t border-border">
        <div className="max-w-container mx-auto px-6 md:px-12">
          <Reveal><Overline>Our credentials</Overline></Reveal>
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {accreditations.map((a, i) => (
              <Reveal key={a.name} delay={(i % 3) * 0.06}>
                <div data-testid={`accreditation-${i}`} className="group bg-surface border border-border p-8 h-full hover:border-brand/50 transition-colors duration-300">
                  <BadgeCheck size={32} className="text-brand-light" strokeWidth={1.5} />
                  <h3 className="mt-6 font-display font-semibold text-2xl text-white tracking-tight">{a.name}</h3>
                  <p className="mt-2 text-slatetxt uppercase text-xs tracking-[0.15em]">{a.note}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-surface py-20 md:py-28">
        <div className="max-w-container mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
            <div className="md:col-span-4">
              <Reveal><Overline>How we stay compliant</Overline></Reveal>
              <Reveal delay={0.05}>
                <h2 className="mt-6 font-display font-bold text-4xl md:text-5xl tracking-tighter text-white leading-[1.05]">
                  Compliance woven into every shift.
                </h2>
              </Reveal>
            </div>
            <div className="md:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {commitments.map((c, i) => {
                const Icon = c.icon;
                return (
                  <Reveal key={c.title} delay={(i % 2) * 0.06}>
                    <div className="bg-ink border border-border p-8 h-full">
                      <Icon size={30} className="text-brand-light" strokeWidth={1.5} />
                      <h3 className="mt-5 font-display font-medium text-xl text-white tracking-tight">{c.title}</h3>
                      <p className="mt-3 text-slatetxt leading-relaxed">{c.body}</p>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
